export const iconFontAwesomeScienceDna = (
	<i className="fa-solid fa-dna"></i>
);
